import React from 'react'
import SubscriptionComponent from '../../components/developerApi/developerSdk/Subscription/SubscriptionComponent'

import './subscriptionLayout.scss'

class SubscriptionLayout extends React.Component {
    render() {
        return <div className="subscription-layout">
            <h2>Subscriptions</h2>
            <h5>Below is the documentation for the Realtime API Callbacks.</h5>
            <SubscriptionComponent api={this.props} />
        </div>
    }
}

export default SubscriptionLayout



// WEBPACK FOOTER //
// ./src/layouts/Subscription/SubscriptionLayout.js